import { SubmitToSandboxSamplesFormView } from '../view/SubmitToSandboxSamplesFormView';
import { templateSubmitToSandboxSamplesForm } from '../view/template';
import { BaseWebComponentController } from '../../../../../framework/BaseWebComponentController';
import { SubmitToSandboxSamplesFormWebComponent } from '..';
import { SubmitToSandboxSamplesFormWebComponentSchema } from '../types';

export class SubmitToSandboxSamplesFormController extends BaseWebComponentController {
  public component: SubmitToSandboxSamplesFormWebComponent;
  public view: SubmitToSandboxSamplesFormView;
  public viewConstructor: typeof SubmitToSandboxSamplesFormView;

  constructor(component: SubmitToSandboxSamplesFormWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: SubmitToSandboxSamplesFormView,
      viewTemplate: templateSubmitToSandboxSamplesForm,
    });
  }

  async getDataForView(): Promise<SubmitToSandboxSamplesFormWebComponentSchema> {
    return {};
  }
}
